import axios from "axios";
const baseUrl = "exam/examLog";
export const logAct = data => {
  return axios({
    url: baseUrl + "/add",
    method: "post",
    data,
  });
};
